import {BookIcon, SmallLoader, Tile} from '@kit';

import React from 'react';

import {getApolloError, imageUrl, variantSrcSet} from '../../components/utils';
import {useBooksQuery} from '../../generated/types';

import pageCss from '../../components/common.module.css';
import css from './books-page.module.css';

/** Полка книг обложками: и на странице раздела, и в конце главной */
export const BookGrid: React.FC<{limit?: number}> = ({limit}) => {
	const {data, loading, error} = useBooksQuery({ssr: true, variables: {available: true}});
	const books = (data?.books || []).slice(0, limit);

	if (error) {
		return <div className={pageCss.fullSizeBlock}>{getApolloError(error).message}</div>;
	}

	if (loading && !books.length) {
		return (
			<div className={pageCss.fullSizeBlock}>
				<SmallLoader />
			</div>
		);
	}

	return (
		<ul className={css.grid}>
			{books.map((book) => (
				<li key={book.id}>
					<Tile
						route="book"
						params={{bookId: book.id}}
						appearance="poster"
						media={
							<span className={css.cover}>
								{book.cover ? (
									<img
										className={css.coverImage}
										src={imageUrl(book.cover, 900)}
										srcSet={variantSrcSet(book.cover)}
										sizes="(max-width: 600px) 90vw, 320px"
										alt=""
										loading="lazy"
									/>
								) : (
									<span className={css.coverEmpty}>
										<BookIcon appearance="color" size={24} />
									</span>
								)}
							</span>
						}
						title={book.title}
					/>
				</li>
			))}
		</ul>
	);
};
